import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft.jsx';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton.jsx';
import PropTypes from 'prop-types';
import FJTitleLine from '../../../../common/combineComponents/FJTitleLine/FJTitleLine.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';

import FJTextAreaWidthInspire from '../../../../common/combineComponents/FJTextAreaWidthInspire/FJTextAreaWidthInspire.jsx';
import { AI_AUDIO_USE_CREDIT } from '../../../../redux/slices/FJSliceAIAudioGenerator.js';

import styles from './FJAIAudioLeft.module.less';
import FJAIAudioLeftT2MContainer from '../container/FJAIAudioLeftT2MContainer.jsx';
import FJAIAudioLeftM2MContainer from '../container/FJAIAudioLeftM2MContainer.jsx';

const FJAIAudioLeft = props => {
    const {
        tabIndex,
        onGenerate,
        taskStatus,
        freeNumCreation,
        isProjectLoading,
        creditNumber,
        prompt,
        onChangePrompt,
        defaultFreeNumCreation,
    } = props;
    const { getInspire } = props;

    const isFree = freeNumCreation > 0 && creditNumber < AI_AUDIO_USE_CREDIT;

    return (
        <FJAppLeft style={{ paddingLeft: 0 }} className={styles.app_left}>
            <FJVerticalScroller className={styles.scroll_box}>
                <div style={{ width: '435px', marginLeft: 21 }}>
                    {tabIndex === 0 && <FJAIAudioLeftT2MContainer />}
                    {tabIndex === 1 && <FJAIAudioLeftM2MContainer />}
                    {tabIndex === 2 && (
                        <>
                            <FJTitleLine
                                title={FJLocalStore._('prompt')}
                                desc={FJLocalStore._(
                                    'please-describe-the-sound-effect-you-want-to-generate-with-a-maximum-of-200-characters',
                                )}
                                isRequire={true}
                                isShowTry={false}
                                style={{ marginTop: 0 }}
                            />
                            <FJTextAreaWidthInspire
                                hasGuide={false}
                                hasInspireInReight={true}
                                placeholder={FJLocalStore._('describe-the-sound-effect-you-want-to-generate')}
                                getInspire={getInspire}
                                text={prompt}
                                onChange={onChangePrompt}
                                maxByteLength={200}
                            />
                        </>
                    )}
                </div>
            </FJVerticalScroller>

            <div style={{ paddingLeft: 21 }}>
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={AI_AUDIO_USE_CREDIT}
                    isProjectLoading={isProjectLoading}
                    style={{ marginTop: '24px' }}
                    isShowUsageDetail={true}
                    defaultFreeNumCreation={defaultFreeNumCreation}
                />
            </div>
        </FJAppLeft>
    );
};

FJAIAudioLeft.propTypes = {
    currentRatio: PropTypes.string,
    changeRatio: PropTypes.func,
    onChangeQuality: PropTypes.func,
    onChangeDuration: PropTypes.func,
    currentQuality: PropTypes.number,
    currentDuration: PropTypes.number,
    tabIndex: PropTypes.number,
    onChangeTabIndex: PropTypes.func,
    originImage: PropTypes.object,
    textValue: PropTypes.string,
    onTextValueChange: PropTypes.func,
    uploadFile: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    uploadStatus: PropTypes.string,
    getInspire: PropTypes.func,
    showAIImageHistoryList: PropTypes.func,
    onFileDelete: PropTypes.func,

    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    peopleImageInfo: PropTypes.object,
    clothesImageInfo: PropTypes.object,
    onUploadImage: PropTypes.func,
    selectedStyle: PropTypes.string,
    onSelectStyle: PropTypes.func,
    isProjectLoading: PropTypes.bool,

    uploadAudioFile: PropTypes.func,
    audioInfo: PropTypes.object,
    uploadAudioStatus: PropTypes.string,
    uploadVocalAudioFile: PropTypes.func,
    vocalAudioInfo: PropTypes.object,
    uploadVocalAudioStatus: PropTypes.string,
    lyricContent: PropTypes.string,
    onLyricContentChange: PropTypes.func,
    onLyricDescChange: PropTypes.func,
    lyricDesc: PropTypes.string,

    clearAudioInfo: PropTypes.func,
    clearVocalAudioInfo: PropTypes.func,
    clearIncidentalAudioInfo: PropTypes.func,
    uploadIncidentalAudioFile: PropTypes.func,

    incidentalAudioInfo: PropTypes.object,
    uploadIncidentalAudioStatus: PropTypes.string,

    generateLyrics: PropTypes.func,
    isGenerateLyricsLoading: PropTypes.bool,

    isDraggingVoiceFile: PropTypes.bool,
    setIsDraggingVoiceFile: PropTypes.func,

    onRecordClick: PropTypes.func,
    onUseSampleInIncidentalFile: PropTypes.func,
    onUseSampleInAudioFile: PropTypes.func,
    onUseSampleInVoiceFile: PropTypes.func,
    prompt: PropTypes.string,
    onChangePrompt: PropTypes.func,

    openMediaLibraryByIncidentalAudio: PropTypes.func,
    openMediaLibraryByAudio: PropTypes.func,
    openMediaLibraryByVocalAudio: PropTypes.func,

    musicDuration: PropTypes.number,
    instrumentalDuration: PropTypes.number,
    onChangeMusicDuration: PropTypes.func,
    onChangeInstrumentalDuration: PropTypes.func,

    subTabIndex: PropTypes.number,
    onChangeSubTab: PropTypes.func,
};
export default FJAIAudioLeft;
